import {
	Component, OnInit, OnChanges, SimpleChanges, OnDestroy,
	ViewChild
} from '@angular/core';
import { MessageService } from 'base';
import { MonitorService } from 'monitor';
import { MonitorConfigComponentBase } from '../MonitorConfigComponentBase';
import { ScheduleComponent } from 'base';
import { Schedule } from 'DiscoveryEngine.TS/Utils';

@Component({
	selector: 'monitor-schedule',
	templateUrl: './monitorschedule.component.html',
	styleUrls: ['./monitorschedule.component.scss']
})
export class MonitorScheduleComponent extends MonitorConfigComponentBase implements OnInit, OnChanges, OnDestroy {

    @ViewChild(ScheduleComponent, { static: true })
	public schedComponent: ScheduleComponent;

	public schedule: Schedule;

	constructor(private monService: MonitorService,
		private messageService: MessageService) {

		super();
		this.schedule = null;
	}

	public ngOnInit(): void {

	}

	public ngOnChanges(changes: SimpleChanges): void {

		if (!!this.editor && this.editor.HasPolicy) {
			this.schedule = this.editor.Policy.Schedule;
		}
		else {
			this.schedule = null;
		}
	}

	public ngOnDestroy(): void {

	}

	public get value(): Schedule {
		return this.schedComponent.value;
	}

	public BuildForm(): void {
		if (this.schedComponent) {
			this.schedComponent.BuildForm();
		}
	}

	public applyTempChanges(): void {
		if (this.schedComponent) {
			this.schedComponent.applyTempChanges();
		}
	}

	public get invalidTempChanges(): string[] {
		return ["Schedule"];
	}

	public get tempChanges(): boolean {
		if (!!this.schedComponent && !!this.schedComponent.SettingsForm) {
			return this.schedComponent.SettingsForm.dirty;
		}
		else {
			return false;
		}
	}

	public get tempChangesValid(): boolean {
		if (!!this.schedComponent && !!this.schedComponent.SettingsForm) {
			return this.schedComponent.SettingsForm.valid;
		}
		else {
			return false;
		}
	}

}
